<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form @submit.prevent="onSubmit">
        <v-card-title class="d-flex justify-center pb-0">
          <span class="headline">{{
            mess.dialog_create_lead_success_title
          }}</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col class="d-flex justify-center">
                <v-btn
                  tag="a"
                  target="_blank"
                  href="/cart"
                  x-large
                  depressed
                  color="primary"
                  >{{ mess.dialog_create_lead_success_button_cart }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateLeadSuccessDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    onSubmit() {}
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  }
};
</script>

<style lang="scss"></style>
